import {useAutocomplete} from "./context/GlobalContext";
import {Form} from "./components/Form/Form";
import {Products} from "./components/Products/Products";

export function AppAutocomplete() {
    const {autocomplete, searchRef, panelRef} = useAutocomplete();
    const { autocompleteState } = useAutocomplete();
    const isOpen = autocompleteState.isOpen;

    return (
        <div className="algoliaAutocomplete" {...autocomplete.getRootProps({})}>
            <Form />

            {isOpen && (
                <div className="algoliaAutocomplete__layout">
                    <section
                        className="algoliaAutocomplete__content"
                        ref={panelRef}
                        {...autocomplete.getPanelProps({})}
                    >
                        <div className="algoliaAutocomplete__results" ref={searchRef}>
                            <Products />
                        </div>
                    </section>
                </div>
            )}
        </div>
    );
}
